import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import type { Currency } from "../../../data/BaseEntity";
import type { Price } from "../../../misc/price";

interface Props {
  readonly price: Price;
  readonly currency: Currency | undefined;
  readonly numberOfPeople?: number;
}

const ProductsTotalPrice: FC<Props> = ({ price, currency, numberOfPeople }) => {
  if (!currency) {
    return (
      <Stack
        sx={{
          alignItems: "center",
          justifyItems: "center",
        }}
      />
    );
  }
  const priceWithCurrency = price.toDisplayValue(currency);
  const pricePerPerson =
    numberOfPeople && price.isPresent()
      ? `${price.divideBy(numberOfPeople).round().toDisplayValue(currency)}/os.`
      : undefined;
  return (
    <Stack
      sx={{
        alignItems: "center",
        justifyItems: "center",
      }}
    >
      <Typography variant="h6" data-testid="products-total-price">
        {priceWithCurrency}
      </Typography>
      {numberOfPeople && (
        <Typography variant="h6" data-testid="products-price-per-person">
          {pricePerPerson}
        </Typography>
      )}
    </Stack>
  );
};

export default ProductsTotalPrice;
